export default __webpack_public_path__ + "static/media/unbounce.4868f25c.svg";